// CheckPagesModal.jsx
import React, { useEffect, useState } from 'react';
import s from '../styles/CheckPagesModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const CheckPagesModal = ({ googleId, projectId, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/projects/check/used_pages', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ href: googleId, sheet_names: projectId }),
        });

        const data = await response.json();

        if (data.error) {
          setResult({ success: false, message: 'Ошибка: ' + data.error });
        } else if (data.missing.length === 0) {
          setResult({ success: true, message: 'Все листы найдены.' });
        } else {
          setResult({
            success: false,
            message: `Не найдены листы: ${data.missing.join(', ')}`,
          });
        }
      } catch (err) {
        setResult({ success: false, message: 'Ошибка при запросе к серверу.' });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [googleId, projectId]);

  return (
    <div className={s.modalOverlay}>
      <div className={s.modalContent}>
        <button className={s.close} onClick={onClose}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>

        <h3>Проверка наличия листов</h3>

        {loading ? (
          <div className={s.loading}><FontAwesomeIcon icon={faSpinner} spin /> Проверка...</div>
        ) : (
          <div className={result.success ? s.success : s.error}>
            {result.message}
          </div>
        )}

        {!loading && (
          <div className={s.warning}>
            Проверьте наличие листов в Гугл таблице. Проверьте наличие пробелов,
            возможно в названии есть пробел в начале или конце.
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckPagesModal;
